<div class="modal-md budget-details">
  <div class="modal-header state">
    <h1
      class="modal-title text-truncate full-width text-align-center"
      id="modal-label"
    >
      Budget Information
    </h1>
    <button
      type="button"
      (click)="close()"
      class="close btn btn-icon"
      aria-label="Close"
    >
      <span class="fal fa-times" aria-hidden="true"></span>
    </button>
  </div>
  <div class="modal-body">
    @for (budget of budgets; track budget) {
      <div class="mt-4 pb-3">
        <h2
          [innerHTML]="budget.label | safeContent"
          class="text-center text-transformation-none fw-normal"
        ></h2>
        <div class="mt-4">
          <div class="d-flex justify-content-between">
            <span>BUDGET AVAILABLE</span>
            <span class="price fw-normal font-2">{{
              budget.available | currency
            }}</span>
          </div>
          <div
            class="d-flex justify-content-between mt-3 pb-3 line-separator--light-grey"
          >
            <span>BUDGET APPLIED</span>
            <span class="green price fw-normal font-2"
              >-{{ budget.applied | currency }}</span
            >
          </div>
          <div class="d-flex justify-content-between mt-3">
            <span>BUDGET REMAINING</span>
            <span class="price fw-bold font-2">{{
              budget.remaining | currency
            }}</span>
          </div>
        </div>
      </div>
    }
  </div>
</div>
